module.exports = __webpack_public_path__ + "img/docking-3.ae93ab1c.png";